import './styles/variables.css'
import './styles/animations.css'
import './styles/media.css'
import './styles/global.css'

import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import "react-datepicker/dist/react-datepicker.css";
import { AuthProvider } from 'oidc-react';
import Routers from './Routers';
import Toast from './antd/hooks/toast';
import { ToastContainer, toast } from 'react-toastify';

export default function App () {

    const oidcConfig = {
        onSignIn: () => {
            window.location.hash = '';
        },
        authority: process.env.REACT_APP_IDENTITY_SERVER_URL,
        clientId: process.env.REACT_APP_CLIENT_ID,
        responseType: 'id_token token',
        redirectUri: window.location.href,
        automaticSilentRenew: true,
    };

    return (
        <AuthProvider  {...oidcConfig}>
            <Toast>
                <ToastContainer/>
                <div className='app'>
                    <Routers />
                </div>
            </Toast>
        </AuthProvider >
    );
}
